import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Loader2, CalendarX2 } from "lucide-react";

const fmt12 = (t) => { const [h, m] = t.split(":").map(Number); return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${h < 12 ? "AM" : "PM"}`; };
export const todayIST = () => new Date(Date.now() + 330 * 60000).toISOString().slice(0, 10);

export default function SlotPicker({ doctorId, date, onDateChange, value, onChange, testid = "slot-picker" }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!doctorId || !date) { setData(null); return; }
    let stale = false;
    setLoading(true);
    api.get("/public/slots", { params: { doctor_id: doctorId, date } })
      .then((r) => { if (!stale) setData(r.data); })
      .catch(() => { if (!stale) setData({ closed: true, reason: "Could not load slots", slots: [] }); })
      .finally(() => { if (!stale) setLoading(false); });
    return () => { stale = true; };
  }, [doctorId, date]);

  return (
    <div className="space-y-3" data-testid={testid}>
      <div className="space-y-2">
        <Label>Date</Label>
        <Input data-testid="slot-date-input" className="h-12" type="date" min={todayIST()} value={date} onChange={(e) => { onDateChange(e.target.value); onChange(""); }} />
      </div>
      {!doctorId && <p className="text-sm text-slate-400">Select a doctor to see available times.</p>}
      {doctorId && date && (
        <div>
          <Label>Available Time Slots</Label>
          {loading ? <div className="flex items-center gap-2 text-sm text-slate-400 mt-2"><Loader2 className="h-4 w-4 animate-spin" /> Loading slots…</div>
            : data?.closed ? <div className="mt-2 flex items-center gap-2 text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded-xl px-3 py-2" data-testid="slots-closed"><CalendarX2 className="h-4 w-4" /> {data.reason}</div>
            : (
              <div className="mt-2 grid grid-cols-3 sm:grid-cols-4 gap-2" data-testid="slot-grid">
                {data?.slots.map((s) => (
                  <button key={s.time} type="button" disabled={!s.available} onClick={() => onChange(s.time)} data-testid={`slot-${s.time}`}
                    className={`h-11 rounded-xl text-sm font-medium border transition-colors ${value === s.time ? "bg-teal-600 text-white border-teal-600" : s.available ? "bg-white border-slate-200 hover:border-teal-500 hover:text-teal-700" : "bg-slate-100 text-slate-300 border-slate-100 line-through cursor-not-allowed"}`}>
                    {fmt12(s.time)}
                  </button>
                ))}
                {data?.slots.every((s) => !s.available) && <p className="col-span-full text-sm text-slate-500" data-testid="slots-full">All slots are booked for this day. Try another date.</p>}
              </div>
            )}
        </div>
      )}
    </div>
  );
}
